import * as React from "react";
import { Genome } from "../../../api";
import { renderWithLinks } from "../../../utils/html";
import { QualityControlSection } from "../../quality-control";
import ExomeQCSection from "../../exome-qc-section";
import { QualityControlWrapper } from "../../quality-control";
import RNASeqQCSection from "../../rnaseq-qc-section";

export const CellBioDetailsQCPanel = ({ genome }: { genome: Genome }) => {
  return (
    <QualityControlWrapper singleColumn={true}>
      <ExomeQCSection genome={genome} />
      <RNASeqQCSection genome={genome} />
      {genome.attributes.atcc_metadata?.notes ? (
        <>
          <QualityControlSection header="Notes">
            <p>{renderWithLinks(genome.attributes.atcc_metadata?.notes)}</p>
          </QualityControlSection>
        </>
      ) : null}
    </QualityControlWrapper>
  );
};
